import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../../context/AppContext";
import {
  DeleteTenant,
  GetTenantDetailById,
  UpdateTenantLicense,
  TenantLicenseTokenHistoryModel,
  GetTenantLicenseTokenHistory,
  CreateTenantLicenseTokenHistory
} from "../../../services/SuperAdminServices/TenantService";
import {
  LicenseModel,
  TenantBasicModel,
  renderLicenseIcon,
  getLicenseColor,
  getLicenseName,
} from "../Tenants/TenantModel";
import {
  Box,
  Heading,
  Text,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Center,
  TableContainer,
  Tooltip,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
  HStack,
  Tag,
  NumberInput,
  NumberInputField,
  Badge,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Divider, useToast
} from "@chakra-ui/react";
import TenantBasicDetailsModal from "./TenantBasicDetailsModal";
import { WarningIcon } from "@chakra-ui/icons";
import TenantLicenseDetailsModal from "./TenantLicenseDetailsModal";
import NotFound from "../../CommonPages/NotFound";


// this page id the the details level of the selected teanat and able to add and manage license part

const TenantDetails: React.FC = () => {
  const { id } = useParams<{ id: number | any }>();
  const { accessToken, userData } = useAppContext();
  const today = new Date();

  const [loading, setLoading] = useState(false);
  const [tenantbasicDetails, setTenantBasicDetails] =
    useState<TenantBasicModel | null>(null);
  const [licenseDetails, setLicenseDetails] = useState<LicenseModel[]>([]);
  const [licenseType, setLicenseType] = useState<number | null>(null);

  // Tenant Modal States
  const [isTenantModalOpen, setIsTenantModalOpen] = useState(false);

  // License Modal States
  const [isLicenseModalOpen, setIsLicenseModalOpen] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState<LicenseModel[] | any>(
    []
  );
  const [selectedLicenseIndex, setSelectedLicenseIndex] = useState<
    number | null
  >(null);

  // Delete Modal States
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTenantId, setDeleteTenantId] = useState<number | null>(null);

  const toast = useToast();
  // Increase Token state
  // Increase Token state
  const [newMaxToken, setNewMaxToken] = useState<number>(0);
  const [activeTokenTab, setActiveTokenTab] = useState<number>(0); // 0 for OpenAI, 1 for CLU
  const [historyData, setHistoryData] = useState<TenantLicenseTokenHistoryModel[]>([]);

  // update in token
  const [isIncreaseModalOpen, setIsIncreaseModalOpen] = useState(false);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const openIncreaseModal = async (lic: LicenseModel) => {
    setSelectedLicense(lic);
    setNewMaxToken(0);
    setActiveTokenTab(0);
    setIsIncreaseModalOpen(true);


    setIsHistoryLoading(true);
    try {
      const data = await GetTenantLicenseTokenHistory(accessToken, lic.TenantLicenseID);
      setHistoryData(data || []);
    } catch (error) {
      console.error("Error fetching token history:", error);
      setHistoryData([]);
    } finally {
      setIsHistoryLoading(false);
    }


  };
  const closeIncreaseModal = () => setIsIncreaseModalOpen(false);

  const [historyModal, setHistoryModal] = useState({
    isOpen: false,
    isLoading: false,
    data: [] as TenantLicenseTokenHistoryModel[],
  });

  // Fetch details when component mounts or id changes
  useEffect(() => {
    if (id) fetchDetails();
  }, [id]);

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const data = await GetTenantDetailById(id, accessToken);
      console.log("tenant Details ===>>>", data);

      if (data) {
        setTenantBasicDetails({
          Id: data.Id,
          TenantID: data.TenantID,
          Name: data.Name,
          Description: data.Description,
          PhoneNumber: data.PhoneNumber,
          Email: data.Email,
          Address: data.Address,
          IsActive: data.IsActive,
          IsTrial: data.IsTrial ?? false,
          DailyProcessLimitPerUser: data.DailyProcessLimitPerUser ?? 10,
          TeamAppId: data.TeamAppId
        });

        // Use data.Licenses directly
        const licenses = data?.Licenses?.map((license: any) => ({
          TenantLicenseID: license.TenantLicenseID,
          LicenseType: license.LicenseType,
          NoOfUsers: license.NoOfUsers,
          LicenseStartDate: license.LicenseStartDate,
          LicenseEndDate: license.LicenseEndDate,
          MaxTokenPerMonth: license.MaxTokenPerMonth,
          LMAndBotTokens: license.LMAndBotTokens,
          assignedLicenses: license.assignedLicenses,
          availableLicenses: license.availableLicenses,
          isLicenseActive: license.isLicenseActive,
          title: license.title
        }));
        console.log("licenses", licenses);
        setLicenseDetails(licenses!);
      } else {
        setTenantBasicDetails(null);
        setLicenseDetails([]);
      }
    } catch (err) {
      console.error("Error fetching tenant details:", err);
    } finally {
      setLoading(false);
    }
  };

  // const confirmIncrease = async () => {
  //   

  //     // Build updated LicenseModel

  //     // await UpdateTenantLicense(updatedLicense, accessToken);
  //     await CreateTenantLicenseTokenHistory()
  //     await fetchDetails();

  //   closeIncreaseModal();
  // };

  const confirmIncrease = async () => {
    if (newMaxToken <= 0) {
      toast({
        position: "top",
        title: "Token should be greater than '0'",
        description: "Please fill in all required fields.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (tenantbasicDetails && selectedLicense) {
      try {
        // Determine if it's OpenAI or CLU based on active tab
        const isOpenAI = activeTokenTab === 0;

        // 1. First create the history record
        const historyRecord: TenantLicenseTokenHistoryModel = {
          TenantLicenseID: selectedLicense.TenantLicenseID,
          OldMaxTokenPerMonth: selectedLicense.MaxTokenPerMonth || 0,
          IsOpenAI: isOpenAI,
          NewMaxTokenPerMonth: newMaxToken,
          CreatedAt: new Date().toISOString(),
          CreatedBy: userData?.userID
        };

        await CreateTenantLicenseTokenHistory(historyRecord, accessToken);

        // 2. Then update the license with new token limit
        // const updatedLicense: LicenseModel = {
        //   ...tenantbasicDetails,
        //   ...selectedLicense,
        //   MaxTokenPerMonth: newMaxToken
        // };

        const updatedLicense: LicenseModel = {
          ...tenantbasicDetails,
          ...selectedLicense,
          MaxTokenPerMonth: isOpenAI ? newMaxToken : selectedLicense.MaxTokenPerMonth,
          LMAndBotTokens: !isOpenAI ? newMaxToken : selectedLicense.LMAndBotTokens,
          IsOpenAI: isOpenAI
        };


        await UpdateTenantLicense(updatedLicense, accessToken);

        await fetchDetails();

      } catch (error) {
        console.error("Error updating token limit:", error);
        // You might want to add error handling/toast notification here
      } finally {
        closeIncreaseModal();
      }
    }
  };

  // basic details of Tenant model
  const openTenantModal = (tenant: TenantBasicModel) => {
    console.log("::tenant::", tenant);
    setTenantBasicDetails(tenant);
    setIsTenantModalOpen(true);
  };

  const closeTenantModal = () => {
    setIsTenantModalOpen(false);
  };

  // Add modal
  const openAddModal = () => {
    
    setSelectedLicense(undefined);
    setSelectedLicenseIndex(null);
    setIsLicenseModalOpen(true);
  };

  // edit model on the
  const openEditModal = (tenantLicenseID: number, lic: LicenseModel) => {
    setSelectedLicenseIndex(tenantLicenseID);
    setSelectedLicense(lic);
    setIsLicenseModalOpen(true);
  };

  const closeLicenseModal = () => {
    setIsLicenseModalOpen(false);
    setSelectedLicense([]);
    setSelectedLicenseIndex(null);
  };

  // delete model
  const openDeleteModal = (tenantId: number, licenseType: number) => {
    setDeleteTenantId(tenantId);
    setLicenseType(licenseType);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteTenantId(null);
    setLicenseType(null);
  };

  const confirmDelete = async () => {
    if (deleteTenantId !== null && licenseType !== null) {
      try {
        await DeleteTenant(deleteTenantId, licenseType, accessToken);
        await fetchDetails(); // Refresh details
      } catch (error) {
        console.error("Error deleting tenant license:", error);
      }
    }
    closeDeleteModal();
  };

  // const openHistoryModal = async (tenantLicenseId: number) => {
  //   setHistoryModal(prev => ({ ...prev, isLoading: true, isOpen: true }));
  //   try {
  //     const data = await GetTenantLicenseTokenHistory(accessToken, tenantLicenseId);
  //     setHistoryModal(prev => ({ ...prev, data: data || [] }));
  //   } catch (error) {
  //     console.error("Error fetching token history:", error);
  //     setHistoryModal(prev => ({ ...prev, data: [] }));
  //   } finally {
  //     setHistoryModal(prev => ({ ...prev, isLoading: false }));
  //   }
  // };

  // const closeHistoryModal = () => {
  //   setHistoryModal(prev => ({ ...prev, isOpen: false, data: [] }));
  // };

  // Handle tab change and reset token value
  const handleTabChange = (index: number) => {
    setActiveTokenTab(index);
    setNewMaxToken(0); // Reset token value when switching tabs
  };

  const getFilteredHistory = () => {
    const isOpenAI = activeTokenTab === 0;
    return historyData.filter(history => history.IsOpenAI === isOpenAI);
  };

  if (loading) {
    return (
      <Center h="100%">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!tenantbasicDetails) {
    // return (
    //   <Center h="100%">
    //     <Text>No tenant found.</Text>
    //   </Center>
    // );
    return <NotFound />;
  }

  if (userData?.roleID !== 3) {
    return <NotFound />;
  }

  return (
    <>
      {tenantbasicDetails && (
        <Flex justify="space-between" align="center" p={4}>
          <Heading as="h2">Tenant Details</Heading>
          <Button
            colorScheme="blue"
            onClick={() => openTenantModal(tenantbasicDetails)}
          >
            <i className="bi bi-person-plus" style={{ marginRight: "8px" }}></i>
            Edit Basic Details
          </Button>
        </Flex>
      )}

      <Box
        p={6}
        shadow="md"
        borderWidth="1px"
        borderRadius={"15px"}
        backgroundColor={"#fff"}
      >
        <VStack spacing={2} align="stretch">
          {(
            [
              ["Tenant ID", tenantbasicDetails.TenantID],
              ["Name", tenantbasicDetails.Name],
              ["Description", tenantbasicDetails.Description],
              ["Phone", tenantbasicDetails.PhoneNumber],
              ["Email", tenantbasicDetails.Email],
              ["Address", tenantbasicDetails.Address],
              ["Status", tenantbasicDetails.IsActive ? "Active" : "Inactive"],
              ["Trial Account", tenantbasicDetails.IsTrial ? "Yes" : "No"],
              ["Daily Limit / User (mails)", tenantbasicDetails.IsTrial ? tenantbasicDetails.DailyProcessLimitPerUser ?? 10 : "N/A"],
              ["Daily Limit / User (documents)", tenantbasicDetails.IsTrial ? tenantbasicDetails.DailyProcessLimitPerUser ?? 10 : "N/A"],
              ["MSTeams ID", tenantbasicDetails.TeamAppId],
              [
                "Current Date",
                new Date().toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  timeZone: "UTC", // Force UTC formatting
                }),
              ],
            ] as [string, any][]
          ).map(([label, value]) => (
            <Flex key={label} mb={2}>
              <Text fontWeight="bold" w="150px">
                {label}:
              </Text>
              <Text>{value}</Text>
            </Flex>
          ))}
        </VStack>
      </Box>

      <Flex justify="space-between" align="center" mb={0} p={6}>
        <Heading as="h6" size="md">
          Manage License
        </Heading>

        <Button onClick={openAddModal} colorScheme="blue" mb={4}>
          Add License
        </Button>
      </Flex>
      <Box
        p={6}
        shadow="md"
        borderWidth="1px"
        borderRadius={"15px"}
        backgroundColor={"#fff"}
      >
        <TableContainer borderWidth="1px" borderRadius="md">
          <Table className="Table">
            <Thead>
              <Tr>
                <Th>Type</Th>
                <Th>Title</Th>
                <Th>Total License</Th>
                <Th>Used License</Th>
                <Th>Available License</Th>
                <Th>Start Date</Th>
                <Th>End Date</Th>
                <Th>OpenAI Limit/Mo</Th>
                <Th>LM & Bot Service/Mo</Th>
                <Th>Credit</Th>
                <Th>Status</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {licenseDetails.map((lic) => {
                const startDate = new Date(lic.LicenseStartDate + "Z");
                const endDate = new Date(lic.LicenseEndDate + "Z");

                const isPastStart = startDate > startDate;
                const isLicenceExpire = (startDate <= today && endDate >= today);
                return (
                  <Tr key={lic.TenantLicenseID}>
                    <Td>
                      <HStack>
                        {renderLicenseIcon(lic.LicenseType)}
                        <Tag colorScheme={getLicenseColor(lic.LicenseType)}>
                          {getLicenseName(lic.LicenseType)}
                        </Tag>
                      </HStack>
                    </Td>
                    <Td>{lic.title}</Td>
                    <Td>{lic.NoOfUsers}</Td>
                    <Td>{lic.assignedLicenses}</Td>
                    <Td
                      fontWeight="bold"
                      color={
                        lic.availableLicenses > 0 ? "green.500" : "red.500"
                      }
                    >
                      {lic.availableLicenses}
                    </Td>
                    <Td>
                      {startDate.toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </Td>
                    <Td>
                      {endDate.toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                      {today >= startDate && today <= endDate ? (
                        <Badge colorScheme="green" ml={2} mt={0} width="fit-content">
                          In Use
                        </Badge>
                      ) : today > endDate ? (
                        <Badge colorScheme="red" ml={2} mt={0} width="fit-content">
                          Expired
                        </Badge>
                      ) : (
                        <Badge colorScheme="yellow" ml={2} mt={0} width="fit-content">
                          Pending
                        </Badge>
                      )}
                    </Td>
                    {/* <Td>
                      {new Date(lic.LicenseEndDate + "Z").toLocaleDateString(
                        "en-US",
                        { year: "numeric", month: "short", day: "numeric" }
                      )}
                    </Td> */}
                    <Td>{lic.MaxTokenPerMonth ?? "-"}</Td>
                    <Td>{lic.LMAndBotTokens ?? "-"}</Td>
                    <Td>{lic.MaxTokenPerMonth ? Math.ceil(lic.MaxTokenPerMonth / 500) : "-"}</Td>
                    <Td>
                      <span
                        className={`status-box ${lic.isLicenseActive ? "active" : "inactive"
                          }`}
                      >
                        {lic.isLicenseActive ? "Active" : "Inactive"}
                      </span>
                    </Td>

                    <Td>
                      <Flex>
                        <Tooltip
                          label={
                            isPastStart ? "License is in Use" : "Edit License"
                          }
                          placement="top"
                        >
                          <Button
                            size="sm"
                            colorScheme="blue"
                            mr={2}
                            onClick={() =>
                              // !isPastStart &&
                              openEditModal(lic.TenantLicenseID, lic)
                            }
                          // disabled={isPastStart}
                          >
                            <i className="bi bi-pencil-square"></i>
                          </Button>
                        </Tooltip>
                        <Tooltip label="Remove license" placement="top">
                          <Button
                            size="sm"
                            colorScheme="red"
                            mr={2}
                            onClick={() => openDeleteModal(id, lic.LicenseType)}
                            disabled={isLicenceExpire}
                          >
                            <i className="bi bi-trash3"></i>
                          </Button>
                        </Tooltip>
                        {(lic.LicenseType === 103 || lic.LicenseType === 102) && (
                          <Tooltip
                            label=" Increase Token Limit"
                            placement="top"
                          >
                            <Button
                              size="sm"
                              colorScheme="green"
                              onClick={() => openIncreaseModal(lic)}
                              disabled={!isLicenceExpire}
                            >
                              <i className="bi bi-graph-up-arrow"></i>
                            </Button>
                          </Tooltip>
                        )}
                      </Flex>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>

      {/* Tenant Form Modal */}
      <TenantBasicDetailsModal
        isOpen={isTenantModalOpen}
        onClose={closeTenantModal}
        onSave={fetchDetails}
        tenantbasicDetails={tenantbasicDetails}
      />

      <TenantLicenseDetailsModal
        isOpen={isLicenseModalOpen}
        onClose={closeLicenseModal}
        onSave={fetchDetails}
        licenseDetail={selectedLicense!}
        tenantDetails={tenantbasicDetails}
        licenseIndex={selectedLicenseIndex!}
      />

      {/* Delete Tenant Modal */}
      <Modal isOpen={isDeleteModalOpen} onClose={closeDeleteModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <WarningIcon color="red.500" boxSize={5} mr={3} />
            Delete license
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex align="center" gap={2}>
              <Text>
                Are you sure you want to delete this tenant license (
                {licenseType}) - TenantID {deleteTenantId}?
              </Text>
              {renderLicenseIcon(licenseType!)}
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={confirmDelete}>
              Yes, Delete
            </Button>
            <Button variant="ghost" onClick={closeDeleteModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Increase Limit Modal */}
      <Modal isOpen={isIncreaseModalOpen} onClose={closeIncreaseModal} size="xl">
        <ModalOverlay />
        <ModalContent maxW="800px">
          <ModalHeader>
            <Text>Increase Token Limit</Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Tabs index={activeTokenTab} onChange={handleTabChange} variant="enclosed">
              <TabList>
                <Tab>
                  <HStack spacing={2}>
                    <i className="bi bi-robot"></i>
                    <Text>OpenAI Token</Text>
                  </HStack>
                </Tab>
                <Tab>
                  <HStack spacing={2}>
                    <i className="bi bi-cloud"></i>
                    <Text>CLU Token</Text>
                  </HStack>
                </Tab>
              </TabList>

              <TabPanels>
                {/* OpenAI Token Panel */}
                <TabPanel>
                  <VStack align="start" spacing={4}>
                    <Text fontWeight="bold" color="blue.600">
                      OpenAI Token Configuration
                    </Text>
                    <Text>
                      Current OpenAI Limit: {selectedLicense?.MaxTokenPerMonth ?? "N/A"}
                    </Text>
                    <Box w="full">
                      <Text mb={2} fontSize="sm" color="gray.600">
                        New OpenAI Token Limit:
                      </Text>
                      <NumberInput
                        value={newMaxToken}
                        min={0}
                        onChange={(_, value) => setNewMaxToken(value)}
                        w="full"
                      >
                        <NumberInputField placeholder="Enter new OpenAI token limit" />
                      </NumberInput>
                    </Box>
                  </VStack>
                </TabPanel>

                {/* CLU Token Panel */}
                <TabPanel>
                  <VStack align="start" spacing={4}>
                    <Text fontWeight="bold" color="green.600">
                      CLU & Bot Service Token Configuration
                    </Text>
                    <Text>
                      Current CLU Limit: {selectedLicense?.LMAndBotTokens ?? "N/A"}
                    </Text>
                    <Box w="full">
                      <Text mb={2} fontSize="sm" color="gray.600">
                        New CLU Token Limit:
                      </Text>
                      <NumberInput
                        value={newMaxToken}
                        min={0}
                        onChange={(_, value) => setNewMaxToken(value)}
                        w="full"
                      >
                        <NumberInputField placeholder="Enter new CLU token limit" />
                      </NumberInput>
                    </Box>
                  </VStack>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>
          <ModalFooter>
            <VStack w="full" spacing={4}>
              {/* Action Buttons */}
              <HStack spacing={3} justify="flex-end" w="full">
                <Button colorScheme="blue" onClick={confirmIncrease}>
                  {/* Save {activeTokenTab === 0 ? 'OpenAI' : 'CLU'} Token Limit */}
                  Save
                </Button>
                <Button variant="ghost" onClick={closeIncreaseModal}>
                  Cancel
                </Button>
              </HStack>

              {/* Divider */}
              <Divider />

              {/* History Section */}
              <Box w="full">
                <Text fontWeight="bold" mb={3} color="gray.700">
                  {activeTokenTab === 0 ? 'OpenAI' : 'CLU'} Token History
                </Text>

                {isHistoryLoading ? (
                  <Center h="100px">
                    <Spinner size="lg" />
                  </Center>
                ) : (
                  <Box maxH="300px" overflowY="auto">
                    {getFilteredHistory().length === 0 ? (
                      <Text color="gray.500" textAlign="center" py={4}>
                        No {activeTokenTab === 0 ? 'OpenAI' : 'CLU'} token history found
                      </Text>
                    ) : (
                      <TableContainer>
                        <Table variant="simple" size="sm">
                          <Thead>
                            <Tr>
                              <Th>Date</Th>
                              <Th>Old Value</Th>
                              <Th>New Value</Th>
                              {/* <Th>Type</Th> */}
                            </Tr>
                          </Thead>
                          <Tbody>
                            {getFilteredHistory().map((history, index) => (
                              <Tr key={history.HistoryID || index}>
                                <Td>
                                  {new Date(history.CreatedAt).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </Td>
                                <Td>{history.OldMaxTokenPerMonth}</Td>
                                <Td>{history.NewMaxTokenPerMonth}</Td>
                                {/* <Td>
                                  <Badge colorScheme={history.IsOpenAI ? "blue" : "green"}>
                                    {history.IsOpenAI ? "OpenAI" : "CLU"}
                                  </Badge>
                                </Td> */}
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                )}
              </Box>
            </VStack>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* History Model */}
      {/* <TokenHistoryModal
        isOpen={historyModal.isOpen}
        onClose={closeHistoryModal}
        historyData={historyModal.data}
        isLoading={historyModal.isLoading}
      /> */}
    </>
  );
};

export default TenantDetails;
